var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.pageTitle
    },
    scopedSlots: _vm._u([{
      key: "bottom",
      fn: function () {
        return [_c('tabs', {
          attrs: {
            "tabs": _vm.tabs
          }
        })];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "my-esims-wrapper"
  }, [_c('nuxt-child')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }